import React, { useState } from 'react';
import { Checkbox } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import { change, Field } from 'redux-form';
import Button from '../../elements/Button';
import ImagePicker from '../../elements/ImagePicker/ImagePicker';
import LoadingBars from '../../elements/LoadingBars';
import styles from './styles.scoped.css';
import PropTypes from 'prop-types';
import Banner from '../../elements/Banner';
import IconFailed from '../../icons/IconFailed';
import TextArea from '../../fields/TextArea';

export default function Component({
  handleSubmit,
  onClose,
  isLoading,
  isTooManyRequests,
  minute = '00',
  second = '00',
}) {
  const dispatch = useDispatch();
  const [file, setFile] = useState([]);
  const { values } = useSelector((state) => state.form.FormNikActivatedSingle);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = {
      supportDocument: file[0] || null,
      reason: values.reason || '',
    };
    handleSubmit(data);
  };

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <Field
        component={TextArea}
        inputProps={{
          label: 'Alasan Membuka Blokir Pelanggan',
          placeholder: 'Tulis alasan membuka blokir pelanggan',
          rows: 4
        }}
        name="reason"
        onChange={(e) => {
          change('FormNikActivatedSingle', 'reason', e.target.value);
        }}
        required
        rows={4}
      />
      <ImagePicker
        accept={['application/pdf', 'application/msword']}
        info={'Format file .doc atau .pdf dan tidak lebih dari 2 Mb'}
        maxSize={2000000}
        onSelect={setFile}
        // required={true}
        title={'Dokumen Pendukung'}
      />
      <Field
        component={Checkbox}
        label="Saya yakin untuk membuka blokir NIK pelanggan ini"
        name="agree"
        onClick={(e) => dispatch(change('FormNikActivatedSingle', 'agree', e.target.checked))}
        styles={{
          body: {
            alignItems: 'center'
          },
          label: {
            color: '#212121',
            fontWeight: 400,
            fontSize: '14px'
          }
        }}
      />
      {isTooManyRequests
        && (
          <Banner
            className={styles.banner}
            desc={<>
              Sudah submit CSV 5 kali dalam satu menit.
              Anda dapat submit file CSV kembali setelah <strong>{minute}:{second}</strong></>}
            icon={<IconFailed />}
            type="danger" />
        )}
      <div className={styles.actions}>
        <Button fullWidth onClick={onClose} style={'outlined'} type="button">
          Batal
        </Button>
        <Button
          className={styles.btnAction}
          disabled={!values.agree || !values.reason || isLoading || isTooManyRequests}
          fullWidth
          style={'blue'}
          type="submit">
          {isLoading && <LoadingBars size={1} />}
          Buka Blokir NIK Pelanggan
        </Button>
      </div>
    </form>
  );
}

Component.defaultProps = {
  handleSubmit: () => { },
  isLoading: false,
  isTooManyRequests: false,
  minute: '00',
  second: '00',
};

Component.propTypes = {
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  isTooManyRequests: PropTypes.bool,
  minute: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  second: PropTypes.string,
};
